import React, { Component } from "react";
import { connect } from "react-redux";
import { LoginComponent } from "./LoginComponent";
import { login } from "../actions";
import { reduxForm } from "redux-form";
import { setWarningMessage } from "../../../messages/actions";
import UserWrapper from "../shared/UserWrapper";
import { translate } from "react-i18next";
class LoginContainer extends Component {
  componentDidUpdate() {
    if (this.props.user) this.props.history.push("/");
  }

  render() {
    return (
      <UserWrapper>
        <LoginComponent {...this.props} />
      </UserWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    phase: state.account.phase,
    user: state.account.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: values => {
      if (!values) return;
      if (!values.email) {
        dispatch(setWarningMessage("Login can't be empty"));
        return;
      }
      if (!values.password) {
        dispatch(setWarningMessage("Password can't be empty"));
        return;
      }

      dispatch(login(values));
    },
    login: creds => {
      dispatch(login(creds));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "login"
  })(translate("translations")(LoginContainer))
);



// WEBPACK FOOTER //
// ./src/users/loggedUser/Login/index.js